export default __webpack_public_path__ + "static/media/library-management-placeholder-header.e74b64f5.svg";